<template>
    <div class="full-width flex align-center + justify-between passage__item">
        <div class="flex align-center">
            <!-- {{ props.one.passageAccuracyRate }} -->
            <span v-if="type === 100" class="mapBoxTtTag blue">맞춤학습</span>
            <span v-if="type === 200" class="mapBoxTtTag green">맞춤학습</span>
            <span v-if="type === 300" class="mapBoxTtTag red">수능모의평가</span>
            <span v-if="type === 400" class="mapBoxTtTag pink">추천학습</span>
            <span v-if="type === 500" class="mapBoxTtTag purple">추천학습</span>
            <span v-if="type === 600" class="mapBoxTtTag pink">진단추천</span>
            <span v-if="type === 700" class="mapBoxTtTag pink">수능모의평가 리셋</span>
            <span v-if="type === 800" class="mapBoxTtTag pink">추천리셋</span>
            <span v-if="type === 900" class="mapBoxTtTag pink">맞춤리셋</span>
            <!-- <q-chip v-if="props?.isTop" dense color="#eaf8ee" size="md">{{ props.one.learningType }}</q-chip> -->
 
            <span class="mapBoxTtLevles">{{ props.one.level }} &nbsp;&nbsp;{{ props.one.lesson }}</span>

            <span class="mapBoxTtNormal passage">{{ props.one.passageArea }}&nbsp;-&nbsp;{{ props.one.passageNumber }}&nbsp;-&nbsp;{{ props.one.passageClass }}&nbsp;-&nbsp;{{ props.one.passageName }} </span>
        </div>
        <div class="mapBoxTtPer" v-if="props.one.passageAccuracyRate > -1">{{ props.one.passageAccuracyRate }}%</div>
    </div>
</template>

<script setup>
import { onMounted, computed, ref, watch, defineProps } from 'vue';
import Comm from '@/components/common.js';

const props = defineProps({
    isTop: {
        Type: Boolean,
        required: true,
    },
    one: {
        Type: Object,
        required: true,
    },
});

const type = computed(() => {
    return Comm.getNoOfStudyType(true, props.one.learningType);
});
// watch(props.kind, (newProps, oldProps) => {
//     console.log('--watch-props-newProps', newProps);
//     console.log('--watch-props-oldProps', oldProps);
// });

// const kind = computed(() => props.kind);

onMounted(() => {
    // console.log('--one-props-', props.one);
});
////////////////////////////----OnClick----////////////////////////////
// const onMㄴㅇㄹㅇㄴㄹㄴㅇㄹInfo = () => {};
</script>

<style scoped lang="scss">
// .blue {
//     background-color: #d8f6ff;
// }
// .green {
//     background-color: #eaf8ee;
// }
// .pink {
//     background-color: #fbebef;
// }
// .purple {
//     background-color: #e8dfff;
// }
// .red {
//     background-color: #fbebef;
// }
// .cyan {
//     background-color: #d8f6ff;
// }
.passage__item {
    padding: 1.08vmin 0;

    &:first-of-type {
        padding-top: 0;
    }

    &:last-of-type {
        padding-bottom: 0;
    }
}
.mapBoxTtTag {
    margin-left: 0;
    padding: 0.58vmin 1.33vmin;
}
.passage {
    display: inline-block;
    @include text-ellipsis;
    max-width: 33vw;
}
</style>
